<template>
  <div class="home-content">
    <div class="container">
      <slot name="fakeMobDiv"></slot>
      <slot name="header"></slot>

      <div class="body">
        <div class="sidea">
          <slot name="sidea"></slot>
        </div>
        <slot name="bar"></slot>
        <div class="sideb">
          <slot name="sideb"></slot>
        </div>
      </div>

      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeContent",
  components: {},
};
</script>
